import { useParams } from "react-router-dom";
import { CaseDetail } from "@/features/cases/components/case-detail";
import { useActiveClient } from "@/layouts/client-layout";

export default function ClientCaseDetailPage() {
  const { client } = useActiveClient();
  const { caseId } = useParams<{ caseId: string }>();
  return <CaseDetail clientId={client.id} caseId={caseId!} />;
}
